import ReportsDetailsMonthOptions from './ReportsDetailsMonthOptions';

export default ReportsDetailsMonthOptions;
